module.exports = __webpack_public_path__ + "img/uptin-poc.4a911a5b.svg";